import track from './track'

$('.plan .btn-more-info').click(function (e) {
    e.preventDefault()
    let name = $(this).parents('.panel-price').find('.panel-heading .panel-name').text()
    let body = $(this).parents('.panel-body').find('.panel-description').html()
    let m = $('#plan-modal')

    m.find('.modal-title').text(name)
    m.find('.modal-body').html(body)
    m.modal()
})

$('.plan .btn-cta').click(function (e) {
    track.event({
        eventCategory: "orders",
        eventAction: "access",
        eventLabel: this.dataset?.label ?? 'UNKNOWN'
    })
});

$('#plan-modal .btn-chat').click(function (e) {
    e.preventDefault()

    let msg = $(this).data('msg') ?? ':)'
    let name = $(this).parents('#plan-modal').find('.modal-title').text()

    $(this).parents('#plan-modal').modal('hide')

    if (typeof window.$crisp !== 'object') {
        console.group('open chat')
        console.log([msg + name])
        console.groupEnd()
        return
    }

    if ($crisp.is('chat:hidden')) return

    if ($crisp.is('chat:closed')) $crisp.push(['do', 'chat:open'])

    $crisp.push(['set', 'message:text', [msg + name]])
})

